<template>
  <div class="page-container">
    <!-- Overlay de carregamento -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>

    <!-- Cabeçalho da página -->
    <div class="header-container">
      <h2 class="title">Solicitações de Transferências</h2>
      <v-text-field v-model="search" append-icon="mdi-magnify"
        label="Pesquisar estudante, instituição, proveniência ou destino" outlined dense clearable
        hide-details class="search-bar"></v-text-field>
    </div>

    <!-- Diálogo para visualizar observação -->
    <v-dialog v-model="dialogObservacao" max-width="400px">
      <v-card>
        <v-card-title class="headline">Observação</v-card-title>
        <v-card-text>
          <p>{{ observacaoSelecionada }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogObservacao = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Tabela de solicitações -->
    <v-data-table :headers="headers" :items="solicitacoes" :search="search" class="data-table" fixed-header>
      <!-- Coluna de índice personalizado -->
      <template v-slot:item.index="{ item }">
        <span>{{ solicitacoes.indexOf(item) + 1 }}</span>
      </template>

      <!-- Coluna de status -->
      <template v-slot:item.imsValidation="{ item }">
        <v-chip :color="item.imsValidation == 1 ? 'green' : 'orange'" dark>
          {{ item.imsValidation == 1 ? 'Aprovado' : 'Pendente' }}
        </v-chip>
      </template>

      <!-- Coluna de classe -->
      <template v-slot:item.idanoacademico="{ item }">
        <span>{{ getClassDescription(item.idanoacademico) }}</span>
      </template>

      <!-- Coluna de ações -->
      <template v-slot:item.action="{ item }">
        <v-menu bottom origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on }">
            <v-btn fab small color="primary" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="autorizarTransferencia(item)" v-if="!isIMS">
              <v-icon color="green" small class="mr-2">mdi-shield-check</v-icon>
              Autorizar
            </v-list-item> 
            <v-list-item @click="rejeitarTransferencia(item)" v-if="!isIMS">
              <v-icon color="red" small class="mr-2">mdi-close-circle</v-icon>
              Rejeitar
            </v-list-item>
            <v-list-item v-if="item.validationNote.length" @click="visualizarObs(item)">
              <v-icon color="green" small class="mr-2">mdi-note-text</v-icon>
              Visualizar observação
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from '../../../plugins/axios';
import Swal from 'sweetalert2';
const ls = require('local-storage');

export default {
  data() {
    return {
      headers: [
        { text: "#", value: "index" },
        { text: "Estudante", value: "nomeEstudante" },
        { text: "Matrícula", value: "idMatricula" },
        { text: "Curso", value: "descricao" },
        { text: "Classe", value: "idanoacademico" },
        { text: "Resultado", value: "resultado" },
        { text: "Proveniência", value: "origem" },
        { text: "Destino", value: "nomeinstituicaoDestino" },
        { text: "Data (solicitação)", value: "requestDate" },
        { text: "Autor (solicitação)", value: "nomeUsuario" },
        { text: "Estado", value: "imsValidation" },
        { text: "Ação", value: "action", align: "center" }
      ],
      solicitacoes: [],
      isLoading: false,
      search: "",
      dialogObservacao: false,
      observacaoSelecionada: "",
    };
  },

  computed: {
    // Nome do usuário logado
    loggedUserName() {
      return ls.get('nomeUsuario');
    },
    // Verifica se o usuário é do IMS
    isIMS() {
      return ls.get("i_id") == 144 || ls.get("i_id") == 1 ? false : true;
    },
  },

  created() {
    this.carregarSolicitacoes();
  },

  methods: {
    // Carrega as solicitações de transferência
    async carregarSolicitacoes() {
      this.isLoading = true;
      try {
        this.solicitacoes = await axios.get('/getSolicitacoesTransferencia').then((res) => res.data);
        this.$store.state.solicitacoesTransferenciaPendentes = this.solicitacoes.length;
      } catch (error) {
        Swal.fire('Informação', 'Erro ao carregar as solicitações de transferência!', 'error');
      } finally {
        this.isLoading = false;
      }
    },

    // Exibe a observação selecionada
    visualizarObs(item) {
      this.observacaoSelecionada = item.validationNote;
      this.dialogObservacao = true;
    },

    // Rejeita uma solicitação de transferência
    async rejeitarTransferencia(item) {
      const params = {
        idcontrolo_transferencia: item.idcontrolo_transferencia,
        autor: this.loggedUserName,
        observacao: ""
      };

      const htmlContent = `
        <p style="text-align: center;">
          <strong style="color: red;">OBS:</strong> O nome do autor da rejeição e a data serão armazenados.
        </p>
        <div style="width: 100%; max-width: 400px; margin: 0 auto; text-align: left;">
          <div style="display: grid; grid-template-columns: 150px auto; gap: 5px;">
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Estudante:</strong></div>
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1); text-align: right;"> ${item.nomeEstudante} </div>
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Classe:</strong></div>
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1); text-align: right;">
              ${this.getClassDescription(item.idanoacademico)}
            </div>
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Proveniência:</strong></div>
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1); text-align: right;"> ${item.origem} </div>
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Destino:</strong></div>
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1); text-align: right;"> ${item.nomeinstituicaoDestino}</div>
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Anulado por:</strong></div>
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1); text-align: right;"> ${params.autor}</div>
          </div>
        </div>
        <label for="swal-input" style="display:block; margin-top:10px;"><strong>Motivo da rejeição*</strong></label>
        <input id="swal-input" class="swal2-input" autocomplete="off" placeholder="Digite o motivo da rejeição..." style="width: 60%;">
      `;

      try {
        const result = await Swal.fire({
          title: "Rejeitar transferência",
          html: htmlContent,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "red",
          cancelButtonColor: "#6c757d",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Rejeitar",
          reverseButtons: true,
          position: "center",
          customClass: {
            popup: "no-scroll-popup"
          },
          preConfirm: () => {
            const observacao = document.getElementById("swal-input").value.trim();
            if (!observacao) {
              Swal.showValidationMessage("O motivo da rejeição é obrigatório!");
              return false;
            }
            params.observacao = observacao;
          }
        });

        if (result.isConfirmed) {
          const response = await axios.post('/rejeitarTransferencia', params);
          if (response.status == 200) {
            Swal.fire('Informação', 'Solicitação rejeitada com sucesso!', 'success');
            this.carregarSolicitacoes();
          } else {
            Swal.fire('Informação', 'Erro ao rejeitar a solicitação de transferência!', 'error');
          }
        }
      } catch (error) {
        Swal.fire('Informação', 'Erro ao realizar a operação!', 'error');
      } finally {
        this.isLoading = false;
      }
    },

    // Autoriza uma solicitação de transferência
    async autorizarTransferencia(item) {
      const params = {
        idcontrolo_transferencia: item.idcontrolo_transferencia,
        idInscricao_na_turma: item.idInscricao_na_turma,
        autor: this.loggedUserName,
        observacao: ""
      };

      const htmlContent = `
        <p style="text-align: center;">
          <strong style="color: red;">OBS:</strong> O nome do autor da autorização e a data serão armazenados.
        </p>
        <div style="width: 100%; max-width: 400px; margin: 0 auto; text-align: left;">
          <div style="display: grid; grid-template-columns: 150px auto; gap: 5px;">
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Estudante:</strong></div>
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1); text-align: right;"> ${item.nomeEstudante} </div>
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Classe:</strong></div>
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1); text-align: right;">
              ${this.getClassDescription(item.idanoacademico)}
            </div>
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Proveniência:</strong></div>
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1); text-align: right;"> ${item.origem} </div>
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Destino:</strong></div>
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1); text-align: right;"> ${item.nomeinstituicaoDestino}</div>
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Autorizado por:</strong></div>
            <div style="border-bottom: 2px solid rgba(0, 0, 0, 0.1); text-align: right;"> ${params.autor}</div>
          </div>
        </div>
        <label for="swal-input" style="display:block; margin-top:10px;"><strong>Observação (Opcional):</strong></label>
        <input id="swal-input" class="swal2-input" autocomplete="off" placeholder="Digite sua observação aqui..." style="width: 60%;">
      `;

      try {
        const result = await Swal.fire({
          title: "Autorizar transferência",
          html: htmlContent,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "green",
          cancelButtonColor: "#d33",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Finalizar",
          reverseButtons: true,
          position: "center",
          customClass: {
            popup: "no-scroll-popup"
          },
          preConfirm: () => {
            const observacao = document.getElementById("swal-input").value;
            params.observacao = observacao.trim();
          }
        });

        if (result.isConfirmed) {
          const response = await axios.post('/autorizarTranferencia', params);
          if (response.status == 200) {
            Swal.fire('Informação', 'Solicitação autorizada com sucesso!', 'success');
            this.carregarSolicitacoes();
          } else {
            Swal.fire('Informação', 'Erro ao autorizar a solicitação de transferência!', 'error');
          }
        }
      } catch (error) {
        Swal.fire('Informação', 'Erro ao realizar a operação!', 'error');
      } finally {
        this.isLoading = false;
      }
    },

    // Retorna a descrição da classe com base no ID
    getClassDescription(id) {
      switch (id) {
        case 1: return '10ª';
        case 2: return '12ª';
        case 3: return '12ª';
        default: return '13ª';
      }
    }
  }
};
</script>

<style scoped>
.page-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background-color: #f5f5f5;
  overflow: hidden;
}

.search-bar {
  width: 100%;
}

.data-table {
  width: 95%;
  margin: auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.header-container {
  display: grid;
  justify-content: space-between;
  grid-template-columns: 0.5fr 0.7fr 0.5fr;
  width: 100%;
  padding: 10px 25px;
  align-items: center;
}

.title {
  color: #3f51b5;
  font-weight: bold;
  font-size: 24px;
}

.no-scroll-popup {
  overflow: hidden;
}
</style>